import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/GalleryPageComponents/HeroSection";
import GallerySection from "../components/GalleryPageComponents/GallerySection";

export default function galleryPage(){
    return(<div>
        <MainLayout>
            <HeroSection/>
            <GallerySection />
        </MainLayout>
    </div>)
    
}